(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', initLookbookPro);
document.addEventListener('DOMContentLoaded', initLookbookPro);

function initLookbookPro() {
  const wrapper = document.querySelector('.js-lookbook-wrapper');
  if (!wrapper) return;

  const slider = wrapper.querySelector('.js-lookbook-3d-slider');
  const cards = Array.from(slider.querySelectorAll('.js-3d-card'));
  let currentIndex = 0;
  let autoplayTimer = null;

  const isAutoplay = wrapper.getAttribute('data-autoplay') === 'true';
  const autoplaySpeed = parseInt(wrapper.getAttribute('data-speed')) || 5000;

  let touchStartX = 0;
  let touchEndX = 0;
  const minSwipeDistance = 40;

  function closeAllMobileProducts() {
    cards.forEach(card => card.classList.remove('mobile-products-open'));
  }

  function updateCarousel() {
    cards.forEach((card, index) => {
      card.classList.remove('is-active', 'is-prev', 'is-next', 'is-prev-2', 'is-next-2');
      const total = cards.length;
      
      if (index === currentIndex) {
        card.classList.add('is-active');
      } else if (index === (currentIndex - 1 + total) % total) {
        card.classList.add('is-prev');
      } else if (index === (currentIndex + 1) % total) {
        card.classList.add('is-next');
      } else if (index === (currentIndex - 2 + total) % total) {
        card.classList.add('is-prev-2');
      } else if (index === (currentIndex + 2) % total) {
        card.classList.add('is-next-2');
      }
    });
  }

  function handleSwipe() {
    const distance = touchEndX - touchStartX;
    if (Math.abs(distance) < minSwipeDistance) return;

    if (distance < 0) {
      currentIndex = (currentIndex + 1) % cards.length;
    } else {
      currentIndex = (currentIndex - 1 + cards.length) % cards.length;
    }
    closeAllMobileProducts();
    updateCarousel();
    startAutoplay();
  }

  function startAutoplay() {
    const anyOverlayOpen = cards.some(c => c.classList.contains('mobile-products-open'));
    if (!isAutoplay || anyOverlayOpen) return;
    
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      currentIndex = (currentIndex + 1) % cards.length;
      updateCarousel();
    }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  // Swipe gesture handlers
  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  slider.addEventListener('touchend', (e) => {
    // Se l'utente interagisce con l'overlay dei prodotti, non attiviamo lo swipe del carosello
    if (e.target.closest('.js-mobile-overlay')) return;
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  // Cambiamento slide al click sulle card laterali
  cards.forEach((card, index) => {
    card.addEventListener('click', (e) => {
      if (e.target.closest('a') || e.target.closest('button')) return;
      if (index !== currentIndex) {
        closeAllMobileProducts();
        currentIndex = index;
        updateCarousel();
        startAutoplay();
      }
    });
  });

  // Gestione pulsanti "Scopri i capi" e "Chiudi" su mobile
  const toggleButtons = wrapper.querySelectorAll('.js-toggle-products');
  toggleButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const currentCard = btn.closest('.js-3d-card');
      
      if (currentCard.classList.contains('mobile-products-open')) {
        currentCard.classList.remove('mobile-products-open');
        startAutoplay();
      } else {
        closeAllMobileProducts();
        currentCard.classList.add('mobile-products-open');
        stopAutoplay();
      }
    });
  });

  wrapper.addEventListener('mouseenter', stopAutoplay);
  wrapper.addEventListener('mouseleave', startAutoplay);

  updateCarousel();
  startAutoplay();
}

  } catch(e) { console.error(e); }
})();
})();
